export default __webpack_public_path__ + "locales/az/Common.json?hash=19aef5d7d93ab53effd93a487c24e2bb";